import YICUClassPage from "./YICUClassPage";
export default function Yicu2018() {
  return <YICUClassPage year="2018" wip={true} />;
}